import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import swal from "sweetalert";
import Select from "react-select";
import { utils } from "~/utils";
import { service as cpo_service } from "../redux";

class PRValidationReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            input_circles_value: ""
        };
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <Formik onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                const { values, setFieldValue } = formik;
                                return (
                                    <Form>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <Field
                                                name="status"
                                                component={Select}
                                                value={values.status}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                options={[
                                                    { value: "not_started", label: "NOT STARTED" },
                                                    { value: "in_progress", label: "IN PROGRESS" },
                                                    { value: "success", label: "SUCCESS" },
                                                    { value: "error", label: "ERROR" }
                                                ]}
                                                onChange={val => setFieldValue("status", val, false)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Type process</label>
                                            <Field
                                                name="type_process"
                                                component={Select}
                                                value={values.type_process}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                options={[
                                                    { value: "email", label: "EMAIL" },
                                                    { value: "user", label: "USER" }
                                                ]}
                                                onChange={val => setFieldValue("type_process", val, false)}
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-success float-right">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        let request = utils.clearObjectNulls({
            status: values && values.status ? values.status.value : null,
            type_process: values && values.type_process ? values.type_process.value : null
        });

        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };

        this.setState({ isLoadig: true });

        cpo_service
            .getPRValidationReport(request)
            .then(() => this.setState({ isLoadig: false }))
            .catch(_ => {
                this.setState({ isLoadig: false });
                errorMessage();
            });
    };
}

export default PRValidationReport;
